import { render, staticRenderFns } from "./ExpertFeedbackModal.vue?vue&type=template&id=618072b4&scoped=true&"
import script from "./ExpertFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./ExpertFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpertFeedbackModal.vue?vue&type=style&index=0&id=618072b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618072b4",
  null
  
)

export default component.exports